export default __webpack_public_path__ + "static/media/chemistry1.3715234e.JPG";